module.exports = __webpack_public_path__ + "static/media/1POLICY21.fdea41c1.jpg";